// product-form.js

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      // Sélectionner le formulaire à l'intérieur de l'élément personnalisé
      this.form = this.querySelector('form');
      if (this.form) {
        // Activer l'input avec le nom 'id'
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) {
          idInput.disabled = false;
        } else {
          console.warn("Input avec le nom 'id' introuvable dans le formulaire.");
        }

        // Ajouter un écouteur d'événement pour la soumission du formulaire
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      } else {
        console.warn("Formulaire introuvable dans 'product-form'.");
      }

      // Référence à l'élément 'cart-notification'
      this.cartNotification = document.querySelector('cart-notification');
      if (!this.cartNotification) {
        console.warn("Élément <cart-notification> introuvable.");
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton && submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      //this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!document.querySelector(".ajax-cart-disabled")) {
        if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
          formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        } else {
          console.warn("Méthode getSectionsToRender() non disponible sur CartNotification.");
        }
      }
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          //window.scrollTo({top: 0, behavior: 'smooth'});
          if (document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents(response);
          }
          openCartDrawer();
          buttonTextChange();
          initMotivatorProduct();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) {
        console.warn("Élément avec la classe 'product-form__error-message-wrapper' introuvable.");
        return;
      }

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      if (this.errorMessageWrapper) {
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      }

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
